<template>
  <div class="input-group">
    <input class="form-control form-control-sm" type="text" v-model="value" />
    <button type="button" class="btn btn-outline-secondary  fas fa-qrcode" @click="openScan"></button>
    <b-modal :visible="isLoading"
             centered             
             hide-header
             hide-footer
             content-class="bg-transparent border-0">
    <div class="text-center">
      <video id="index__video" ref="video" preload autoplay loop muted/>
      <canvas 
      :width="canvasWidth"
      :height="canvasHeight"
      id="canvas"      
      ref="canvasElement"
      ></canvas>
    </div>
    </b-modal>
  </div>  
</template>

<script>
import adapter from 'webrtc-adapter'
import jsQR from 'jsqr'

export default {
  name: "mmf-qrcode",
  props: {
    "text": {
      type: String
    }    
  },
  data() {
    return{
      value : this.text,
      userMedia: null,
      camera: null,
      video: document.createElement('video'),
      loadingMessage: '🎥 Unable to access video stream (please make sure you have a webcam enabled)',
      isLoading: Boolean,
      showCanvas: true,
      canvas2d: undefined,
      canvasWidth: 200,
      canvasHeight: 200
    }    
  },
  destroyed () {
    this.closeCamera()
  },
  methods: {
    openScan () {
      // const g = this;
      // this.userMedia = navigator.getUserMedia || navigator.webkitGetUserMedia 
      //                 || navigator.mozGetUserMedia;
      // if (g.userMedia) {
      //   navigator.getUserMedia(
      //     { video: { width: 200, height: 200 } },
      //     function(stream) {}
      //     );
      // }
      this.isLoading = true;      
      const videoParam = { video: true }
      console.log(this.video)
      navigator.mediaDevices.getUserMedia(videoParam).then((stream) => {
        this.video.srcObject = stream
        // this.video.setAttribute('playsinline', true) // required to tell iOS safari we don't want fullscreen
        this.video.play()
        requestAnimationFrame(this.tick)
      })
    },
    // 关闭摄像头
    closeCamera () {
      if (this.video.srcObject) {
        this.video.srcObject.getTracks().forEach(function (track) {
          track.stop()
        })
      }
      this.canvas2d = undefined
    },
    tick () {
      this.loadingMessage = '⌛ Loading video...'
      if (this.video.readyState === this.video.HAVE_ENOUGH_DATA) {
        this.showCanvas = true
        this.canvasHeight = this.video.videoHeight
        this.canvasWidth = this.video.videoWidth
        !this.canvas2d && (this.canvas2d = this.$refs.canvasElement.getContext('2d'))
        this.canvas2d.drawImage(this.video, 0, 0, this.canvasWidth, this.canvasHeight)
        var imageData = this.canvas2d.getImageData(0, 0, this.canvasWidth, this.canvasHeight)
        var code = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: 'dontInvert'
        })
        if (code) {
          this.drawLine(code.location.topLeftCorner, code.location.topRightCorner, '#FF3B58')
          this.drawLine(code.location.topRightCorner, code.location.bottomRightCorner, '#FF3B58')
          this.drawLine(code.location.bottomRightCorner, code.location.bottomLeftCorner, '#FF3B58')
          this.drawLine(code.location.bottomLeftCorner, code.location.topLeftCorner, '#FF3B58')
          this.value = code.data
          console.log(code.data)
          this.closeCamera()
          this.isLoading = false
          return
        } else {
          // this.text = undefined
        }
      }
      requestAnimationFrame(this.tick)
    },
    drawLine (begin, end, color) {
      this.canvas2d.beginPath()
      this.canvas2d.moveTo(begin.x, begin.y)
      this.canvas2d.lineTo(end.x, end.y)
      this.canvas2d.lineWidth = 4
      this.canvas2d.strokeStyle = color
      this.canvas2d.stroke()
    }
    
   
  }
};
</script>

<style lang="scss" scoped>
.v-body {
  font-family: "Ropa Sans", sans-serif;
  color: #333;
  max-width: 640px;
  margin: 0 auto;
  position: relative;
}
#githubLink {
  position: absolute;
  right: 0;
  top: 12px;
  color: #2d99ff;
}
h1 {
  margin: 10px 0;
  font-size: 40px;
}
#loadingMessage {
  text-align: center;
  padding: 40px;
  background-color: #eee;
}
#canvas {
  width: 100%;
}
#output {
  margin-top: 20px;
  background: #eee;
  padding: 10px;
  padding-bottom: 0;
}
#output div {
  padding-bottom: 10px;
  word-wrap: break-word;
}
#noQRFound {
  text-align: center;
}
</style>
